<span>{{ renderValue }}
  <!-- <fa name="cog" class="pr-1"></fa> -->
</span>